export default "__VITE_ASSET__DwPk$JS9__"